import React from "react";

const Document = () => (
  <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.5 0.25V19.75H15.5V5.19531L15.2891 4.96094L10.7891 0.460938L10.5547 0.25H0.5ZM2 1.75H9.5V6.25H14V18.25H2V1.75ZM11 2.82812L12.9219 4.75H11V2.82812ZM4.25 7.75V9.25H11.75V7.75H4.25ZM4.25 10.75V12.25H11.75V10.75H4.25ZM4.25 13.75V15.25H11.75V13.75H4.25Z" fill="white"/>
</svg>
);

export default Document;
